<template>
  <div class="fileContainer">
    <div class="fileTitle">律师入驻保密与信息安全承诺书</div>
    <div class="filePart">
      <div>欢迎您入驻本平台。作为入驻律师，您在使用本平台服务过程中，将接触到平台的各类保密信息、用户数据及平台运营信息。本《律师入驻保密与信息安全承诺书》（以下简称“本承诺书”）旨在明确您对平台隐私信息的保护义务、使用限制及违约责任。请您仔细阅读并充分理解本承诺书各项内容，尤其是以加粗或下划线形式标注的保密义务及违约责任条款。当您勾选“我已阅读并同意《律师入驻保密与信息安全承诺书》”，即视为您已充分理解并同意接受本承诺书全部内容。</div>
    </div>
    <div class="filePart">
      <div class="fileMenu">第一条 适用范围</div>
      <div class="fileSubPart">
        <div>为保障本平台的隐私信息安全，明确您入驻后对平台隐私信息的保护义务，根据《中华人民共和国个人信息保护法》《中华人民共和国数据安全法》《中华人民共和国律师法》及《律师入驻服务协议》等法律法规及约定，制定本承诺书。本承诺书适用于您注册入驻、使用平台服务及退出后的全过程。</div>
        <div>您确认并知悉：在处理平台用户个人信息时，平台作为个人信息处理者承担法定责任，您基于入驻协议在平台委托范围内处理用户信息，并承担本承诺书约定的保密与安全义务；您以自身专业身份独立提供法律咨询时，就执业行为依法承担相应责任。</div>
      </div>
    </div>
    <div class="filePart">
      <div class="fileMenu">第二条 术语定义</div>
      <div class="fileSubPart">
        <div>除本承诺书另有约定外，下列词语具有以下含义：</div>
        <p>• 本平台：指为群众提供公共法律服务的平台，包括热线平台、网站、移动客户端、小程序及相关服务系统。</p>
        <p>• 平台隐私信息：指您在使用平台服务过程中接触、获取或了解到的，与平台运营、技术、用户、数据相关的各类保密信息，具体范围见第三条。</p>
        <p>• 平台用户信息：指通过平台注册、咨询或使用服务的自然人、法人或非法人组织的个人信息及其咨询内容。</p>
        <p>• 咨询内容：指用户通过本平台提交的法律问题、案情描述、材料等信息。</p>
        <p>• 敏感个人信息：指一旦泄露或者非法使用，容易导致自然人的人格尊严受到侵害或者人身、财产安全受到危害的个人信息，包括身份证件信息、金融账户信息、健康信息、未成年人信息等。</p>
        <p>• 平台运营数据：指平台为公共服务目的收集、产生的服务记录、统计报表、内部管理信息等非公开信息。</p>
        <p>• 保密义务：指您根据本承诺书及法律法规规定，对平台隐私信息承担的保密、不泄露、不非法使用及不非法提供的义务。</p>
      </div>
    </div>
    <div class="filePart">
      <div class="fileMenu">第三条 保密信息范围与识别</div>
      <div class="fileSubPart">
        <div>平台隐私信息包括用户个人信息、咨询内容、平台运营数据、平台技术信息及其他依法应予保密的信息，具体类别及内容详见下表：</div>
        <table class="info">
          <thead>
            <tr>
              <th>信息类别</th>
              <th>具体内容</th>
              <th>接触场景</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>用户个人信息</td>
              <td>用户姓名、联系方式、身份信息、咨询记录</td>
              <td>用户发起咨询、律师提供服务时</td>
            </tr>
            <tr>
              <td>咨询内容</td>
              <td>用户描述的法律事项、提交的材料、案情细节等</td>
              <td>提供法律咨询过程中</td>
            </tr>
            <tr>
              <td>平台运营数据</td>
              <td>服务记录、统计报表、审核记录、内部管理数据等</td>
              <td>查看平台后台、接受平台管理时</td>
            </tr>
            <tr>
              <td>平台技术信息</td>
              <td>系统架构、源代码、接口文档、算法、数据库结构</td>
              <td>使用平台开发者工具、API接口时</td>
            </tr>
            <tr>
              <td>其他保密信息</td>
              <td>平台标记为保密或根据法律法规应当保密的其他信息、文件或数据</td>
              <td>任何接触场景</td>
            </tr>
            <tr>
              <td>其他保密信息</td>
              <td>平台标记为保密或根据法律法规应当保密的其他信息、文件或数据</td>
              <td>任何接触场景</td>
            </tr>
          </tbody>
        </table>

        <div>凡属于用户个人信息和咨询内容的，无论是否标记保密，均属于本承诺书保护范围。其他信息仅在未公开且平台明确标示为保密，或法律法规要求保密时，适用本承诺书。</div>
      </div>
    </div>
    <div class="filePart">
      <div class="fileMenu">第四条 保密义务</div>
      <div class="fileSubPart">
        <div class="filePartTitle">（一）一般保密义务</div>
        <div>您应履行以下保密义务：</div>
        <p>• 严格保密：对在使用平台服务过程中获知的平台隐私信息严格保密，不得以任何方式向第三方透露、披露或公开。</p>
        <p>• 限定用途：仅在为平台用户提供服务的目的范围内使用平台隐私信息，不得用于其他任何目的。</p>
        <p>• 期限限制：仅在完成服务事项所必需的期限内保留平台隐私信息，不得超期存储或复制；法律法规、执业规范要求留存的必要案卷信息除外。</p>
        <p>• 及时报告：发现平台隐私信息可能被泄露或已泄露时，应立即通知平台并采取补救措施。</p>
        <p>• 配合审查：配合平台对信息安全事件的调查处理。</p>
        <div class="filePartTitle">（二）用户信息保护义务</div>
        <div>您在接触平台用户信息时，应履行以下义务：</div>
        <p>• 严格保密：对用户的个人信息、咨询内容等予以严格保密，不得向任何第三方透露。</p>
        <p>• 最小授权：仅在提供服务所必需的范围内使用用户信息，不得超出服务目的查看或使用。</p>
        <p>• 禁止导出：不得将用户信息导出平台系统、存储于个人设备或发送至个人邮箱。</p>
        <p>• 安全存储：如确有必要临时记录用户信息，应采取加密等安全措施，并在服务完成后及时删除；法律法规、执业规范要求归档留存的除外，留存信息仍应严格保密并限制用途。</p>
      </div>
    </div>
    <div class="filePart">
      <div class="fileMenu">第五条 保密例外</div>
      <div class="fileSubPart">
        <div>您在服务过程中，如发现用户存在下列情形之一，为保护用户本人、他人生命安全或重大公共利益，您可以在必要范围内向平台报告，并可根据情况向公安机关、医疗机构、应急救援机构等提供与处置紧急事件直接相关的必要信息：</div>
        <p>• 用户存在明确的自伤、自杀或严重危及自身生命健康的危险；</p>
        <p>• 用户正在准备或者实施危害国家安全、公共安全以及严重危害他人人身、财产安全的犯罪行为；</p>
        <p>• 法律、行政法规另有规定的其他情形。</p>
        <p>您披露上述信息应遵循必要原则，仅限于实现紧急救助目的所必需的最小范围。</p>
      </div>
    </div>
    <div class="filePart">
      <div class="fileMenu">第六条 禁止行为</div>
      <div class="fileSubPart">
        <div class="filePartTitle">（一）一般禁止行为</div>
        <div>您严禁从事以下行为：</div>
        <p>• 禁止泄露：向任何第三方透露、披露或公开平台隐私信息，包括但不限于口头、书面、电子邮件、社交媒体等任何方式。</p>
        <p>• 禁止非法使用：将平台隐私信息用于自己或任何人的商业目的，包括但不限于拉客、自行联系用户、跳过平台私下交易等。</p>
        <p>• 禁止存储与复制：以截屏、拍照、复制等方式保存平台隐私信息，或存储于个人设备、云盘等非平台环境。</p>
        <p>• 禁止分析利用：利用平台隐私信息进行数据分析、用户画像、商业研究等非服务目的的活动。</p>
        <p>• 禁止损害公益：利用平台隐私信息从事损害平台公益性质、用户合法权益或社会公共利益的行为。</p>
        <p>• 禁止共享账号：将平台账号、权限出借、转让或共享给任何人使用。</p>
        <p>• 禁止绕过系统：尝试绕过平台安全机制获取未授权的信息。</p>
        <div class="filePartTitle">（二）利用用户信息的特别禁止</div>
        <div>您特别承诺，不得将通过平台接触到的用户信息用于以下目的：</div>
        <p>• 自行联系用户推介服务或诱导用户接受非平台渠道的有偿法律服务；</p>
        <p>• 将用户信息提供给其他律师、律师事务所或任何第三方；</p>
        <p>• 将用户信息用于广告推送、商业营销等非公益服务目的；</p>
        <p>• 出售、交易或变相变现用户信息。</p>
      </div>
    </div>
    <div class="filePart">
      <div class="fileMenu">第七条 安全保护措施与事件报告</div>
      <div class="fileSubPart">
        <div class="filePartTitle">（一）安全保护措施</div>
        <div>您应采取以下措施保障平台隐私信息安全：</div>
        <p>• 账号安全：妥善保管平台账号及密码，定期更改密码，不得使用弱口令。</p>
        <p>• 设备安全：使用平台时确保设备安全，安装杀毒软件和防火墙，避免使用公共Wi-Fi等不安全网络。</p>
        <p>• 屏幕保护：离开工位时及时锁定屏幕，避免平台信息被他人看到。</p>
        <p>• 文件管理：如因服务需要临时保存平台信息文件，应加密存储并在服务完成后删除。</p>
        <div class="filePartTitle">（二）安全事件报告</div>
        <div>您发现或怀疑平台隐私信息发生泄露、损毁、丢失等安全事件时，应立即采取措施防止泄露扩大，并在发现后24小时内向平台报告。报告应包括：事件发生时间、原因分析、可能影响范围、已采取及将采取的措施。</div>
      </div>
    </div>
    <div class="filePart">
      <div class="fileMenu">第八条 信息返还与删除</div>
      <div class="fileSubPart">
        <div class="filePartTitle">（一）信息返还与删除要求</div>
        <div>您在以下情形下，应及时返还或删除平台隐私信息：</div>
        <p>• 服务完成后：服务事项完成后，应将临时保存的平台隐私信息及时删除；法律法规、执业规范要求归档留存的必要案卷信息除外。</p>
        <p>• 协议终止后：本承诺书及《律师入驻服务协议》终止后，应将所有平台隐私信息返还平台或销毁。</p>
        <p>• 平台要求时：平台提出返还或删除要求时，应在5个工作日内配合执行。</p>
        <p>• 法律要求时：法律法规要求删除的其他情形。</p>
        <div class="filePartTitle">（二）删除确认</div>
        <div>您删除平台隐私信息后，应向平台提供删除证明（如删除截图等）。如因服务需要保留部分信息，应明确告知平台保留原因及保留范围，并在不再需要时及时删除。</div>
        <div class="filePart">
          <div class="fileMenu">第九条 保密期限</div>
          <div class="fileSubPart">
            <div>您的保密义务不因本承诺书或《律师入驻服务协议》的终止而终止。保密义务在您退出平台后继续有效，期限为协议终止后五年。对于用户的个人信息及敏感个人信息，保密义务在法律法规规定的保存期限内持续有效，法律法规未规定保存期限的，保密义务长期有效。</div>
          </div>
        </div>
      </div>
    </div>

    <div class="filePart">
      <div class="fileMenu">第十条 违约责任</div>
      <div class="fileSubPart">
        <div class="filePartTitle">（一）违约处置</div>
        <div>您违反本承诺书约定的，平台有权采取以下一项或多项措施：</div>
        <p>• 警告并要求限期整改；</p>
        <p>• 限制部分功能或暂停服务；</p>
        <p>• 暂时封禁账号或永久关闭账号；</p>
        <p>• 取消入驻资格；</p>
        <p>• 保留追究法律责任的权利。</p>
        <div class="filePartTitle">（二）损害赔偿</div>
        <div>若您违反本承诺书约定，造成平台隐私信息泄露、损毁或丢失的，应承担相应的违约赔偿责任，赔偿范围以平台因此遭受的直接损失及合理维权费用（包括诉讼费、律师费、公证费等）为限；因您故意或重大过失造成的损失不受前述限额限制。</div>
        <div>因您泄露用户个人信息导致用户权益受损的，由您及其所在律师事务所依法向受害用户承担赔偿责任。</div>
        <div>您知悉并同意：平台作为个人信息处理者依法承担的行政责任，不通过本承诺书转嫁给您；但因您故意或重大过失直接导致平台受到行政处罚的，平台有权就该等处罚金额向您追偿。</div>
        <div class="filePartTitle">（三）严重情形</div>
        <div>下列情形属于严重违约，平台有权立即终止服务并保留追究责任的权利：</div>
        <p>• 故意泄露平台用户个人信息或敏感信息的；</p>
        <p>• 出售、非法提供平台隐私信息给第三方的；</p>
        <p>• 利用平台隐私信息从事违法犯罪活动的；</p>
        <p>• 造成平台或用户重大损失的其他情形。</p>
      </div>
    </div>
    <div class="filePart">
      <div class="fileMenu">第十一条 承诺书更新</div>
      <div
        class="fileSubPart"
      >平台有权根据法律法规变化及运营需要修订本承诺书，修订后的版本将在平台公示。一般修订自公示之日起生效；涉及扩大保密范围、加重您责任等重大变更的，平台将以显著方式单独提示并要求您重新确认，您不同意的有权停止使用并按约定退出。如您在修订生效后继续使用平台服务，视为接受修订后的版本。</div>
    </div>

    <div class="filePart">
      <div class="fileMenu">第十二条 争议解决</div>
      <div
        class="fileSubPart"
      >因本承诺书引起的争议，您与平台应首先通过友好协商解决；协商不成的，任一方有权向被告住所地、合同履行地或平台住所地有管辖权的人民法院提起诉讼。</div>
    </div>

    <div class="filePart">
      <div class="fileMenu">第十三条 承诺书生效</div>
      <div
        class="fileSubPart"
      >本承诺书以电子形式订立，自您在线勾选“我已阅读并同意《律师入驻保密与信息安全承诺书》”之日起生效。本承诺书以数据电文形式存在，无需另行签署，与书面文件具有同等法律效力。平台将留存您勾选记录、协议版本、时间戳及IP等缔约证据。本承诺书与《律师入驻服务协议》同时适用，两者约定不一致的，以本承诺书为准。</div>
    </div>

    <div class="checkBox">
      <p>
        <Checkbox @on-change="changeValue" disabled v-model="checkBox">隐私保护承诺声明</Checkbox>
      </p>
      <div>本人已仔细阅读并充分理解《律师入驻保密与信息安全承诺书》全部内容，知悉本平台为公共法律服务平台，本人作为入驻律师，在提供公共法律咨询服务过程中接触到的用户个人信息、咨询内容及平台未公开信息均受法律保护。本人郑重承诺：将严格遵守本承诺书约定，切实保障平台隐私信息安全，不得以任何方式泄露、非法使用或向第三方提供平台保密信息。本人同意：本承诺书以电子形式订立，自在线勾选“我已阅读并同意《律师入驻保密与信息安全承诺书》”之日起生效，与手写签名具有同等法律效力。</div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    checked: {
      required: false,
      default: false
    }
  },
  watch: {
    checked: {
      immediate: true,
      handler: function (val, valO) {
        this.checkBox = val
      }
    }
  },
  data () {
    return {
      checkBox: false
    }
  },
  methods: {
    changeValue: function (val) {
      this.checkBox = val
      this.$emit('change', val)
    }
  }
}
</script>
<style lang="less" scoped>
.fileContainer {
  word-wrap: break-word;
  user-select: none;

  font-family: 'Microsoft YaHei', SimHei, sans-serif;
  max-width: 600px;
  margin: auto;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  padding: 1rem;

  .fileTitle {
    text-align: center;
    font-size: 1.2rem;
    font-weight: 600;
  }

  .filePre {
    margin: 10px 0;
  }

  .fileMenu {
    font-size: 1rem;
    font-weight: 600;
    line-height: 2rem;
    margin-bottom: 10px;
  }

  .fileSubMenu {
    font-size: 1rem;
    font-weight: 500;
    margin-bottom: 8px;
  }

  .filePart {
    margin: 10px 0;
    text-indent: 2rem;

    .fileSubPart > {
      margin-bottom: 1rem;

      > p,
      > div {
        margin-bottom: 10px;
      }
    }

    .info {
      width: 100%;
      table-layout: fixed;
      border-collapse: collapse;
      margin-bottom: 10px;

      th {
        font-weight: 600;
        line-height: 3rem;
        text-align: center;
        border: 1px solid #888;
      }

      tbody {
        > tr:nth-child(odd) {
          td {
            background-color: #ecf6ff;
          }
        }
        td {
          text-align: left;
          border: 1px solid #888;
          padding: 6px;
        }
      }
    }

    .filePartTitle {
      font-weight: 500;
      margin-bottom: 6px;
    }

    .filePartContent {
      // font-size: 0.9rem;
    }
  }

  .checkBox {
    background-color: #ecf6ff;
    border: 1px solid #84c7ff;
    padding: 10px;
    line-height: 1.4rem;

    > p {
      font-weight: 600;
      margin-bottom: 6px;
    }
  }
}
</style>